module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fmtitle"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_vm._v("INTRODUCTION")])]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("There’s only one thing better than Christmas movies, and that’s answering questions all about them. We therefore humbly present you with "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Quiz Actually")]), _vm._v(" – a title we totally thought up ourselves not related to any particular film or production. Oh, alright, you got us. But "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Love Actually")]), _vm._v(" is one of our favourite Chrimbo flicks, and you will be able to find questions about it on page 151.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Quiz, Actually")]), _vm._v(" comprises a mix of multiple-choice and straight-down-the-line questions; we like to mix it up around here. And, if that weren’t enough, there’s also all manner of challenges, forfeits, games, and fun activities – indeed, quite a lot of the time there’s no need to have even watched the movie in order to have a good old-fashioned Xmas mess-about LOLtime.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_vm._v("The films are presented alphabetically – no favouritism here, despite what we just said above – and it’s entirely up to ")]), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_vm._v("you whether you take it movie-by-movie and answer all the questions, or pick out the first three of different films, or just dive in and create whatever combination you feel inspired by.")])]), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("There’s enough here for the movie geeks to really go to town, as well as oodles of silliness – what better way could there be to tap into the season of good cheer?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Over to you …")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f1eb624","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/03_Introduction.vue
// module id = 69
// module chunks = 0